import { cva, VariantProps } from 'class-variance-authority';
import { ReactNode } from 'react';

import { cn } from '../../libs/utils';

import { Bullet, BulletArea } from './bullet-variant/bullet-variant';

const textListVariants = cva('flex gap-tiny-large py-tiny-small', {
  variants: {
    size: {
      large: 'body-small-regular',
      medium: 'caption-medium-regular',
      small: 'gap-tiny-medium caption-small-regular'
    },
    variant: {
      bullet: ''
    }
  },
  defaultVariants: {
    size: 'large',
    variant: 'bullet'
  }
});

export interface TextListProps extends VariantProps<typeof textListVariants> {
  children: ReactNode;
  bulletColor?: string;
  className?: string;
}

export function TextList({ children, size = 'medium', variant = 'bullet', bulletColor, className }: TextListProps) {
  return (
    <li className={textListVariants({ size, variant, className })}>
      {variant === 'bullet' && (
        <BulletArea size={size}>
          <Bullet bulletColor={bulletColor} size={size} />
        </BulletArea>
      )}
      {children}
    </li>
  );
}

interface TextListGroupProps {
  children: ReactNode;
  className?: string;
}

export const TextListGroup = ({ children, className }: TextListGroupProps) => {
  return <ul className={cn(className)}>{children}</ul>;
};
